"use client"

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"
import { Button } from "@/components/ui/button"
import { AlertCircle, RefreshCw } from "lucide-react"

interface ErrorMessageProps {
  title?: string
  message: string
  onRetry?: () => void
  retrying?: boolean
}

export function ErrorMessage({
  title = "Něco se pokazilo",
  message,
  onRetry,
  retrying = false,
}: ErrorMessageProps) {
  return (
    <Alert variant="destructive">
      <AlertCircle className="h-4 w-4" />
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription className="mt-2 space-y-3">
        <p className="text-sm">{message}</p>
        {onRetry && (
          <Button
            variant="outline"
            size="sm"
            onClick={onRetry}
            disabled={retrying}
            className="gap-2"
          >
            {retrying ? (
              <>
                <RefreshCw className="h-3 w-3 animate-spin" />
                Zkouším znovu...
              </>
            ) : (
              <>
                <RefreshCw className="h-3 w-3" />
                Zkusit znovu
              </>
            )}
          </Button>
        )}
      </AlertDescription>
    </Alert>
  )
}
